export enum AdminApplicationType {
    SHORT = 'seasons.season-details.application.duration.short',
    LONG = 'seasons.season-details.application.duration.long'
}
